<script>
    import BeenTable from './BeenTable.svelte';

    import { tcc_json } from '$lib/static/tcc_json.js';

    let {
        user_stats_tcc = {},
        switch_state = $bindable(1),
        map = $bindable(null),
        hoveredRegIntId = $bindable(),
    } = $props();

</script>

{#each tcc_json as rrow}
    <BeenTable bind:map bind:hoveredRegIntId db={rrow?.db} user_stats={user_stats_tcc} header={rrow?.region} visited={rrow?.visited} total={rrow?.total} show_switch={0} bind:switch_state/>
{/each}
